module.exports = __webpack_public_path__ + "static/media/oscillosynth.d2bdc402.svg";